<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <h4>Tipos de Elementos</h4>
    <hr />

    <DataTable
      :data="tipoelems"
      :columns="columnas"
      idField="idTipoElem"
      mensajeVacio="No hay tipos de elementos registrados."
      :mostrarBotonNuevo="true"
      :mostrarEditar="true"
      :mostrarVer="true"
      :mostrarEliminar="true"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="row => abrirModalEditar(row.idTipoElem)"
      @view="row => abrirEditar(row.idTipoElem)"
      @delete="row => deleteTipoElem(row.idTipoElem)"
    >
      <!-- Búsqueda por nombre -->
      <template #acciones-extra>
        <div class="col-auto d-flex align-items-center gap-1">
          <input
            type="text"
            class="form-control form-control-sm"
            v-model="nombreBusqueda"
            placeholder="Buscar nombre..."
            style="width:220px; text-transform:uppercase"
            @keyup.enter="getDataNombre"
          />
          <button
            class="btn btn-outline-primary btn-sm"
            @click="getDataNombre"
            title="Buscar"
          >
            <span class="material-icons" style="font-size:16px">search</span>
          </button>
        </div>
      </template>
    </DataTable>

    <!-- ── Modal ──────────────────────────────────────────────────── -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white">
              <i class="fa fa-user-plus"></i> {{ titulo }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-white"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form>
            <div class="modal-body">
              <!-- ID solo en edición -->
              <div class="mb-3" v-if="btnEditar">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">ID</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoTipoElem.idTipoElem"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <!-- Código -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Código</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoTipoElem.codigo"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
              <!-- Nombre -->
              <div class="mb-3">
                <div class="row">
                  <div class="col-2">
                    <label class="form-label fw-bold">Nombre</label>
                  </div>
                  <div class="col-10">
                    <input
                      type="text"
                      class="form-control"
                      v-model="datoTipoElem.nombre"
                      style="text-transform:uppercase"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary"
              @click.prevent="guardarTipoElem"
              v-if="btnCrear"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">save</span>
              Guardar
            </button>
            <button
              type="button"
              class="btn btn-warning"
              @click.prevent="actualizarTipoElem"
              v-if="btnEditar"
            >
              <span class="material-icons me-1" style="font-size:18px;vertical-align:middle">update</span>
              Actualizar
            </button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout          from "@/components/Layout.vue";
import Footer          from "@/components/Footer.vue";
import DataTable       from "@/components/DataTable.vue";
import api             from "@/services/api";
import { validarForm } from "@/modules/validacionesForms.js";
import Swal            from "sweetalert2";
import * as $          from "jquery";
window["$"]      = $;
window["jQuery"] = $;

export default {
  name: "TipoElemList",
  components: { Layout, Footer, DataTable },

  data() {
    return {
      tipoelems:    [],
      datoTipoElem: {},
      nombreBusqueda: "",
      titulo:       "",
      btnCrear:     false,
      btnEditar:    false,
      modalWindow:  true,
    };
  },

  computed: {
    columnas() {
      return [
        { label: "Código", field: "codigo" },
        { label: "Nombre", field: "nombre" },
      ];
    },
  },

  mounted() {
    this.$refs.layoutRef.toggleProcesos();
    this.$refs.layoutRef.toggleReportes();
    this.$refs.layoutRef.toggleParametros();
    this.$refs.layoutRef.toggleAyuda();
    this.getData();
  },

  methods: {
    // ── Carga de datos ────────────────────────────────────────
    getData() {
      this.nombreBusqueda = "";
      api.get("/vwtipoelems")
        .then(r => { this.tipoelems = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al cargar tipos de elementos:", e));
    },

    getDataNombre() {
      const nombre = this.nombreBusqueda.trim();
      if (!nombre) { this.getData(); return; }
      api.get("/vwtipoelems/nombre/" + nombre)
        .then(r => { this.tipoelems = Array.isArray(r.data) ? r.data : []; })
        .catch(e => console.error("Error al buscar tipo de elemento:", e));
    },

    // ── Validación ────────────────────────────────────────────
    validarForm() {
      return validarForm(
        this.datoTipoElem,
        ["codigo", "nombre"],
        ["Código", "Nombre"]
      );
    },

    // ── CRUD ──────────────────────────────────────────────────
    async guardarTipoElem() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/tipoelems", this.datoTipoElem);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Tipo de elemento creado exitosamente." });
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
      }
    },

    async actualizarTipoElem() {
      if (this.validarForm() !== 1) return;
      try {
        await api.post("/tipoelems", this.datoTipoElem);
        $("#ventanaModal").modal("hide");
        Swal.fire({ icon: "success", title: "¡Correcto!", text: "Tipo de elemento actualizado exitosamente." });
        this.getData();
      } catch (error) {
        Swal.fire({ icon: "error", title: "Error", text: "Inténtelo de nuevo." });
        const arr = Object.values(error.response?.data?.errors || {});
        arr.forEach(e => Swal.fire(String(e)));
      }
    },

    async deleteTipoElem(idTipoElem) {
      const confirm = await Swal.fire({
        title:             "¿Eliminar tipo de elemento?",
        text:              "Esta acción no se puede deshacer.",
        icon:              "warning",
        showCancelButton:  true,
        confirmButtonText: "Sí, eliminar",
        cancelButtonText:  "Cancelar",
      });
      if (!confirm.isConfirmed) return;
      try {
        await api.delete("/tipoelems/" + idTipoElem);
        this.getData();
      } catch {
        Swal.fire({ icon: "error", title: "Error", text: "No se pudo eliminar." });
      }
    },

    // ── Modales ───────────────────────────────────────────────
    abrirModalCrear() {
      this.modalWindow  = true;
      this.datoTipoElem = {};
      this.titulo       = "Crear Tipo de Elemento";
      this.btnCrear     = true;
      this.btnEditar    = false;
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    async abrirModalEditar(idTipoElem) {
      this.modalWindow = true;
      this.titulo      = "Editar Tipo de Elemento";
      this.btnCrear    = false;
      this.btnEditar   = true;
      try {
        const resp        = await api.get("/vwtipoelems/" + idTipoElem);
        this.datoTipoElem = resp.data;
      } catch (e) {
        console.error("Error al cargar tipo de elemento:", e);
        return;
      }
      this.$nextTick(() => $("#ventanaModal").modal("show"));
    },

    abrirEditar(idTipoElem) {
      if (idTipoElem != null) this.$router.push("/tipoelem_claselem/" + idTipoElem);
    },
  },
};
</script>